<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <minimizable-modal :name="name"
                           :draggable="'.v-app-bar'"
                           :width="600"
                           height="auto"
                           :reset="true"
                           overlayTransition=""
                           transition=""
                           :clickToClose="false"
                           :shiftX="modalShift.x"
                           :shiftY="modalShift.y"
                           :minimized.sync="minimized"
                           :visible.sync="visible"
        >
            <v-app-bar color="primary" @dblclick="minimized = !minimized">
                <v-toolbar-title>
                    Chains
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-tooltip top v-if="!controller.active">
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               dark
                               v-on="on"
                               v-if="isRegisteredUser()"
                               @click.stop="createModal.visible = true"
                               @dblclick.stop="">
                            <v-icon :size="iconSize">add</v-icon>
                        </v-btn>
                    </template>
                    <span>Add</span>
                </v-tooltip>

                <v-tooltip top v-if="!controller.active && !minimized">
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               :disabled="selectedChains.length !== 1"
                               dark
                               v-on="on"
                               @click.stop="startChain"
                               @dblclick.stop="">
                            <v-icon :size="iconSize">play_arrow</v-icon>
                        </v-btn>
                    </template>
                    <span>Run</span>
                </v-tooltip>

                <v-tooltip top v-else-if="controller.active">
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               dark
                               v-on="on"
                               @click.stop="stop"
                               @dblclick.stop="">
                            <v-icon :size="iconSize">stop</v-icon>
                        </v-btn>
                    </template>
                    <span>Stop</span>
                </v-tooltip>

                <v-tooltip top v-if="!minimized">
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               dark
                               v-on="on"
                               v-if="isRegisteredUser()"
                               @click.stop="importData"
                               @dblclick.stop="">
                            <v-icon>fa-file-import</v-icon>
                        </v-btn>
                    </template>
                    <span>Import</span>
                </v-tooltip>

                <v-tooltip top v-if="!minimized">
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               :disabled="selectedChains.length <= 0"
                               dark
                               v-on="on"
                               @click.stop="exportData"
                               @dblclick.stop="">
                            <v-icon>fa-file-export</v-icon>
                        </v-btn>
                    </template>
                    <span>Export</span>
                </v-tooltip>

                <v-tooltip top v-if="!minimized">
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               :disabled="selectedChains.length <= 0"
                               dark
                               v-on="on"
                               v-if="isRegisteredUser()"
                               @click.stop="deleteSelected"
                               @dblclick.stop="">
                            <v-icon :size="iconSize">delete</v-icon>
                        </v-btn>
                    </template>
                    <span>Delete</span>
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               dark
                               v-on="on"
                               @click.stop="minimized = !minimized"
                               @dblclick.stop="">
                            <v-icon :size="iconSize">{{ minimized ? 'maximize' : 'minimize' }}</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ minimized ? 'Maximize' : 'Minimize' }}</span>
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               dark
                               v-on="on"
                               @click.stop="hide"
                               @dblclick.stop="">
                            <v-icon :size="iconSize">close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close</span>
                </v-tooltip>
            </v-app-bar>

            <v-card v-if="!minimized">
                <div class="pl-5 pr-5" >
                    <v-data-table
                            show-select
                            v-model="selectedChains"
                            :headers="headers"
                            item_key="id"
                            :items="chains"
                            :options.sync="pagination"
                            :hide-default-footer="true"
                            class="elevation-1 fixed-column-table"
                    >
                        <template v-slot:body="{ items }">
                            <tr v-for="(item) in items" :key="item.id">
                                <td>
                                    <v-checkbox v-model="selectedChains" :value="item" class="checkbox ma-0 pa-0"
                                                hide-details></v-checkbox>
                                </td>
                                <td class="text-left">{{ item.name }}</td>
                                <td class="text-left">
                                    <div class="helpIcon" style="width: auto; height: auto">
                                        <span>{{ item.usedModels[0] }}</span>
                                        <span v-for="i in Math.min(item.usedModels.length, 3)" :key="i">
                                        <br>{{ item.usedModels[i] }}
                                    </span>
                                        <span v-if="item.usedModels.length > 3">...</span>
                                    </div>
                                    <span v-if="item.usedModels.length > 3" class="helpText" style="left: 75%; top: auto;">
                                    <span v-for="model in item.usedModels" :key="model">
                                        {{ model }}<br>
                                    </span>
                                </span>
                                </td>
                                <td class="text-left">{{ item.state }}</td>
                                <td class="text-left">
                                    <v-tooltip top v-if="!minimized">
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon
                                                   dark
                                                   v-on="on"
                                                   @click.stop="getBus(item.id).$emit('show')">
                                                <v-icon>details</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Details</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-pagination
                            v-model="pagination.page"
                            :length="pagination.pageCount"
                            :total-visible="5"
                    >
                    </v-pagination>
                </div>
            </v-card>
        </minimizable-modal>

        <joint-list v-for="item of chains" :key="item.id" :chainID="item.id" :bus="getBus(item.id)"></joint-list>

        <div class="blocking">
            <minimizable-modal :name="createModal.name"
                               :draggable="false"
                               :width="300"
                               height="auto"
                               :reset="true"
                               :clickToClose="false"
                               overlayTransition=""
                               transition=""
                               :minimized="false"
                               :visible.sync="createModal.visible"
            >

                <v-app-bar color="primary">
                    <v-toolbar-title>New Chain</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon @click="createModal.visible = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-app-bar>
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex xs8 style="text-align: left">
                                <v-text-field autofocus
                                              hide-details
                                              label="Name"
                                              v-model="createModal.chainName"
                                              single-line
                                              outlined
                                              @keypress.enter="addChain"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs1></v-flex>
                            <v-flex xs3 style="text-align: left">
                                <v-btn color="success" style="width: 100%; height: 100%" @click="addChain">
                                    OK
                                </v-btn>
                            </v-flex>

                        </v-layout>
                    </v-card-text>
                </v-card>
            </minimizable-modal>
        </div>
    </div>
</template>

<script>
    import MinimizableModal from '../../../components/minimizable-modal'
    import JointList from './joint-list.vue';
    import controller from '../controller';
    import {mapState, mapActions} from 'vuex';
    import JSZip from 'jszip';
    import Vue from 'vue';

    const {
        Vector3,
        Matrix4
    } = THREE;

    export default {
        name: "ChainList",

        components: {
            MinimizableModal,
            JointList
        },

        props: {
            bus: {
                required: true,
            }
        },

        computed: {
            ...mapState('kinematics', {
                chains: 'chains'
            })
        },

        data() {
            return {
                name: "chainList",
                headers: [
                    {text: 'Name', value: 'name', align: 'left', width: '35%', sortable: true},
                    {text: 'Used Models', value: 'usedModels', align: 'left', width: '40%', sortable: true},
                    {text: 'State', value: 'state', align: 'left', width: '20%', sortable: true},
                    {text: '', value: '', align: 'left', width: '5%', sortable: false},

                ],
                pagination: {
                    descending: true,
                    page: 1,
                    itemsPerPage: 5,
                    totalItems: 0,
                    pageCount: 1
                },
                minimized: false,
                visible: false,
                modalShift: {
                    x: 0.2,
                    y: 0.0
                },
                iconSize: 25,
                selectedChains: [],
                controller: controller,
                listBuses: {},
                createModal: {
                    name: "newChain",
                    chainName: "",
                    visible: false
                }
            }
        },

        created() {
            this.bus.$on('show', this.show);
            this.bus.$on('hideAll', this.hideAll);
            this.pagination.totalItems = Object.keys(this.chains).length;
            this.pagination.pageCount = Math.ceil(Object.keys(this.chains).length / this.pagination.itemsPerPage);
        },

        methods: {
            ...mapActions('kinematics', {
                start: 'start',
                stop: 'stop',
                insertChain: 'addChain',
                insertJoint: 'addJoint',
                deleteLast: 'deleteLast',
                deleteChain: 'deleteChain',
                deleteAll: 'deleteAll',
                importChain: 'importChain'
            }),

            isRegisteredUser: isRegisteredUser,

            getBus(id) {
                if (!this.listBuses[id]) {
                    this.listBuses[id] = new Vue();
                }

                return this.listBuses[id];
            },

            startChain() {
                this.start(this.selectedChains[0].id);
            },

            addChain() {
                this.insertChain({
                    name: this.createModal.chainName
                });
                this.createModal.chainName = "";
                this.createModal.visible = false;
            },

            importData() {
                let self = this;
                let input = $("#kinematicsInput")[0];

                function onReaderLoad(event){
                    input.value = "";
                    input.removeEventListener("change", handleChange);

                    let obj = JSON.parse(event.target.result);
                    self.importChain(obj);
                }

                function handleChange(event) {
                    self.deleteAll();

                    let reader = new FileReader();
                    reader.onload = onReaderLoad;
                    reader.readAsText(event.target.files[0]);
                }

                input.addEventListener('change', handleChange);

                input.click();
            },

            exportData() {
                const shouldCompress = this.selectedChains.length > 1;
                let zip = new JSZip();

                for (let chain of this.selectedChains) {
                    let sanitizedData = JSON.parse(JSON.stringify(chain));
                    delete sanitizedData.selectedParentNode;
                    delete sanitizedData.state;

                    let dataStr = JSON.stringify(sanitizedData);

                    let fileName = chain.name + '.json';

                    if (shouldCompress) {
                        zip.file(fileName, dataStr);
                    } else {
                        let dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);

                        let link = document.createElement('a');
                        link.setAttribute('href', dataUri);
                        link.setAttribute('download', fileName);
                        link.click();
                    }
                }

                if (shouldCompress) {
                    zip.generateAsync({type: "base64"}).then(data => {
                        let link = document.createElement('a');
                        link.setAttribute('href', "data:application/zip;base64," + data);
                        link.setAttribute('download', "Kinematics.zip");
                        link.click();
                    })
                }
            },

            deleteLastEntry() {
                this.deleteLast();
            },

            deleteSelected() {
                for (let joint of this.selectedChains) {
                    this.deleteChain(joint);
                }
                this.selectedChains.splice(0, this.selectedChains.length);
            },

            show() {
                this.visible = true;
            },

            hide() {
                this.minimized = false;
                this.visible = false;
            },

            hideAll() {
                for (let busID in this.listBuses) {
                    this.listBuses[busID].$emit("hideAll");
                }

                this.hide();
            }
        }
    }
</script>

<style scoped>
    .v-text-field >>> input {
        margin: 0;
    }

    .add-button {
        width: 100%;
        border: 2px white dashed;
        background-color: transparent;
        font-size: 45px;
        padding: 20px 0 !important;
        margin: 10px 0;
    }
</style>
